<section class="our-offers">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12 text-center">
                <h2 class="section-title">العروض التي نقدمها</h2>
            </div>
            <div class="col-md-6">
                <div class="offer-wrapper">
                    <div class="offer-title">
                        <h4>عرض تصميم موقع شركة</h4>
                    </div>
                    <div class="offer-description">
                        <p>
                            اذا لديك شركة فأنت بالطبع تحتاج الى موقع الكتروني لتطوير اعمالك وتتابع الحجوزات الخاصة بالعروض والارتقاء بمستوى شركتك, تحتاج الى موقع بتصميم احترافي يبهر الزائر عند الدخول اليه ويعكس مدى احترافية هذه الشركة, وبالتالي تترك الفرصة لموقعك ان يسوق لك خدماتك دون اى مجهود منك, فأننا نوفر لك عرض تصميم موقع , ونتفهم جيدا متطلباتك ومتطلبات زوارك وعملاءك في هذا الموقع,
                        </p>
                    </div>                    
                    <div class="offer-img">
                        <img src="./../../../assets/images/tabletcar.png" alt="" />
                    </div>                    
                </div>
            </div>
            <div class="col-md-6">
                <div class="offer-wrapper">
                    <div class="offer-title">
                        <h4>عرض تصميم موقع اثاث</h4>
                    </div>
                    <div class="offer-description">
                        <p>
                            هل لديك حلم امتلاك شركة تجني لك الملايين وتجعلك من كبار رجال الاعمال مع شركة كزدس رزتس سنحقق لك الحلم حيث اننا متخصصون في برمجةالمواقع الشبكي بجميع انواعه
                        </p>
                    </div>                    
                    <div class="offer-img">
                        <img src="./../../../assets/images/tabletdecor.png" alt="" />
                    </div>                    
                </div>
            </div> 
            <div class="col-md-6">
                <div class="offer-wrapper">
                    <div class="offer-title">
                        <h4>عرض نظام لادارة المعارض والمانديب</h4>
                    </div>
                    <div class="offer-description">
                        <p>
                            نقدم لك نظام متكامل لادارة معرضك ومناديبك ونقاط التوزيع الخاصه بك مع تحديد اماكن المنايب ومعرفة الحسابات الخاص بالمعرض خاصتك وتحديد مبيعاتك اليوميه والاسبوعية والشهرية وتحديد افضل العملاء لديك وافضل المناديب كما نحدد لك المكاسب والخسائر المحققة من المبيعات لكل
                        </p>
                    </div>                    
                    <div class="offer-img">
                        <img src="./../../../assets/images/tabletfurnutire.png" alt="" />
                    </div>                    
                </div>
            </div>
            <div class="col-md-6">
                <div class="offer-wrapper">
                    <div class="offer-title">
                        <h4>عرض تصميم موقع محاماة</h4>
                    </div>
                    <div class="offer-description">
                        <p>
                            اذا كان لديك شركة او مكتب يقدم خدمات خاصة او استشارات, اذا كنت محامي او مهندس او محاسب قانوني … الخ, ولديك مكتب خاص وتريد موقع بسيط يعرض خدماتك او منتجاتك ويوسع من قاعدة عملائك وزيادة ارباحك, ويعرض معلومات وبيانات الاتصال بشركتك او مكتبك, ويستطيع الزوار ان يتصلو بك ويتواصلو معك من خلال الموقع, اذا تريد موقع الكتروني يساهم في زيادة عدد العملاء لديك, فأننا نقدم لك عرض تصميم موقع شركة, لنساهم في تطوير اعمالك واضافة المزيد من النجاح الى عملك
                        </p>
                    </div>                    
                    <div class="offer-img">
                        <img src="./../../../assets/images/tabletlaw.png" alt="" />
                    </div>                    
                </div>
            </div>            
            <div class="col-md-6">
                <div class="offer-wrapper">
                    <div class="offer-title">
                        <h4>عرض تصميم موقع طبي او مستشفى</h4>
                    </div>
                    <div class="offer-description">
                        <p>
                            اذا كان لديك مستشفى او احد المراكز الطبية العامة او المتخصصة او عيادة , وتريد انشاء موقع الكتروني يعرض الخدمات الطبية التي تقدمها, ويعرض ايضا المميزات الطبية التي توفرها, ويعرض جيدا وبوضوح وبالصور الاقسام الموجودة داخل المستشفى او المركز الطبي التابع لك, واذا كنت تريد ايضا ان يقوم الزوار بعمل الحجوزات الطبية من خلال موقع المستشفى او المركز الطبي, فأننا نقدم لك عرض تصميم موقع مستشفى, حيث نساهم معك في تطوير ادارتك للمستشفى او المركز الطبي الخاص بك او العيادة الخاصة بك 
                        </p>
                    </div>                    
                    <div class="offer-img">
                        <img src="./../../../assets/images/tabletdoctor.png" alt="" />
                    </div>                    
                </div>
            </div>
            <div class="col-md-6">
                <div class="offer-wrapper">
                    <div class="offer-title">
                        <h4>عرض تصميم موقع مدرسة او اكاديمية</h4>
                    </div>
                    <div class="offer-description">
                        <p>
                            اذا لديك مدرسة او جامعة او معهد تعليمي او اكاديمية وتريد ان ترتقي بالعملية التعليمية واستخدام احدث الوسائل والتقنيات في التواصل مع الطلاب واولياء الامور ليضيف اليك ميزة تنافسية بين المدارس او المعاهد التعليمية الاخرى, ولذلك تفكر في عمل موقع يكون بمثابة الوجهة الرئيسية للمدرسة على الانترنت, مما يساهم في تطوير اداء المدرسة ويجعلها تواكب التطور التكنولوجي, فأننا نقدم لك عرض تصميم مدرسة, لنوفر لك الحلول التقنية لتطوير اداء ادارة المدرسة او الجامعة او المعهد او الاكاديمية
                        </p>
                    </div>                    
                    <div class="offer-img">
                        <img src="./../../../assets/images/tabletschool.png" alt="" />
                    </div>                    
                </div>
            </div>                                    
        </div>
    </div>
</section>